export default {"src":"/_next/static/media/flag.6d35a807.gif","height":150,"width":150,"blurWidth":0,"blurHeight":0};